<template>
  <el-table
    :data="times"
    stripe
  >
    <el-table-column
      label="Service"
      prop="service"
      sortable
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue.name || 'All') : 'All'"
    />

    <el-table-column
      label="Zone From"
      prop="from"
      sortable
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
    />

    <el-table-column
      label="Zone To"
      prop="to"
      sortable
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
    />

    <el-table-column
      label="Travel Time"
      prop="travel_time"
      sortable
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
    />
  </el-table>
</template>

<script>
export default {
  props: {
    times: {
      type: Array,
      required: true
    }
  }
}
</script>
